import { Component, OnInit, ViewContainerRef, Input } from '@angular/core';
import { NdmsFormControlComponent } from '../../../../../../shared/ui-ndms/forms/ndms-form-control/ndms-form-control.component';
import { NdmsTextboxSearchComponent } from '../../../../../../shared/ui-ndms/forms/ndms-textbox-search/ndms-textbox-search.component';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'search-team-textbox',
  templateUrl: './search-team-textbox.component.html',
  styleUrls: ['./search-team-textbox.component.scss']
})
export class SearchTeamTextboxComponent extends NdmsFormControlComponent implements OnInit {

  @Input() field: string;
  @Input() group: FormGroup;
  @Input() size: string;
  @Input() placeholder: string;

  @Input() label: string;
  @Input() labelHidden: boolean;

  @Input() required: string;
  
  constructor(viewContainerRef: ViewContainerRef) {
    super(viewContainerRef);
  }

  ngOnInit() {
  }

}
